export const saveCaseHistory = (
  caseID,
  userId,
  preference,
  persistPreference,
) => {
  const preferenceData = preference.get('data').toJS();
  if (
    preferenceData.litigationCaseHistory &&
    preferenceData.litigationCaseHistory.length > 0
  ) {
    preferenceData.litigationCaseHistory = [caseID].concat(
      preferenceData.litigationCaseHistory.filter(id => id !== caseID),
    );
    if (preferenceData.litigationCaseHistory.length > 20) {
      preferenceData.litigationCaseHistory.pop();
    }
  } else {
    preferenceData.litigationCaseHistory = [caseID];
  }
  persistPreference({
    userId,
    data: {
      preference: preferenceData,
    },
  });
};
